import React from "react"

import ActivitiesCollection from "~components/shared/collections/activities-collection"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import COPY_CONSTANTS from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import type { MediaFieldsFragment, FeedGroup } from "~graphql/generated/graphql"
import { useStreamFeed } from "~utils/stream-feeds"

interface Props {
    readonly avatar?: MediaFieldsFragment | null
    readonly title: string
    readonly feedId: string
    readonly feedGroup: FeedGroup
}

export default function Feed({ title, avatar, feedId, feedGroup }: Props) {
    const { isLoading, activities, error, fetchMore, hasMore } = useStreamFeed({
        feedId,
        feedGroup,
    })

    // only set the full container to loading on first fetch,
    // otherwise use loading dots in the feed
    const isFirstLoading = !activities.length && isLoading
    const shouldRenderChildren = activities.length > 0 && !isLoading && !error

    const pageLabel = `${title} ${COPY_CONSTANTS.NEWSFEED}`

    return (
        <div data-testid={TEST_IDS.FEED}>
            <LoadingOrErrorContainer
                shouldRenderChildren={shouldRenderChildren}
                isLoading={isFirstLoading}
                error={error}
            >
                <ActivitiesCollection
                    activities={activities}
                    title={title}
                    avatar={avatar}
                    label={pageLabel}
                    isLoading={isLoading}
                    canFetchMore={hasMore}
                    fetchMore={fetchMore}
                />
            </LoadingOrErrorContainer>
        </div>
    )
}
